/** English translations for the Botilia search widget. */
import type { TranslationKey } from './el.js';

export const en: Record<TranslationKey, string> = {
  // SearchWidget
  'search.placeholder': 'Search wines, varietals, producers...',
  'search.placeholder.short': 'What are you looking for?',
  'search.close': 'Close search',
  'search.clear': 'Clear',
  'search.searching': 'Searching for "{query}"...',
  'search.results': '{count} results',
  'search.products': '{count} products',
  'search.resultsTime': '{count} results in {time}ms',
  'search.loadMore': 'Load more',
  'search.loadMoreCount': '{count} more',
  'search.loading': 'Loading...',
  'search.error': 'Search error',
  'search.aria': 'Search Botilia.gr',
  'search.clickToSearch': 'Click to search',
  'search.showingResultsFor': 'Showing results for',
  'search.category': 'Category:',
  'search.listening': 'Listening...',
  'search.startListening': 'Voice search',
  'search.stopListening': 'Stop listening',
  'search.voiceNotSupported': 'Voice search is not supported in this browser',

  // Filters
  'filter.label': 'Filters',
  'filter.category': 'Category',
  'filter.type': 'Type',
  'filter.wineType': 'Wine Type',
  'filter.country': 'Country',
  'filter.region': 'Region',
  'filter.grape': 'Grape Variety',
  'filter.producer': 'Producer',
  'filter.winery': 'Winery',
  'filter.subcategory': 'Subcategory',
  'filter.vintage': 'Vintage',
  'filter.tags': 'Tags',
  'filter.body': 'Body',
  'filter.acidity': 'Acidity',
  'filter.tannins': 'Tannins',
  'filter.fruitiness': 'Aromatic Intensity',
  'filter.price': 'Price',
  'filter.priceFrom': 'From',
  'filter.priceTo': 'To',
  'filter.inStock': 'In stock',
  'filter.inStockOnly': 'In Stock Only',
  'filter.clearAll': 'Clear all',
  'filter.applyFilters': 'Apply filters',
  'filter.allCategories': 'All categories',
  'filter.showMore': '+{count} more',
  'filter.showLess': 'Show less',
  'filter.resultsCount': '{count} results',
  'filter.showFilters': 'Show filters',
  'filter.hideFilters': 'Hide filters',

  // Sort
  'sort.label': 'Sort',
  'sort.relevance': 'Relevance',
  'sort.priceAsc': 'Price: Low to High',
  'sort.priceDesc': 'Price: High to Low',
  'sort.rating': 'Top Rated',
  'sort.newest': 'Newest',

  // ProductCard
  'product.bestSeller': 'Best Seller',
  'product.promo': 'On Sale',
  'product.outOfStock': 'Out of Stock',
  'product.inStock': 'In Stock',
  'product.notAvailable': 'Not Available',
  'product.savings': 'You save {amount}',
  'product.stars': '{rating} out of 5 stars',

  // NoResults
  'noResults.title': 'No results found',
  'noResults.message': 'No results found for "{query}"',
  'noResults.didYouMean': 'Did you mean:',
  'noResults.popular': 'Popular searches',
  'noResults.tips': 'Try different keywords, check your spelling, or use more general terms.',
  'noResults.tryDifferent': 'Try different keywords or browse the categories',

  // DefaultResults
  'defaults.recentlyViewed': 'Recently viewed',
  'defaults.recentSearches': 'Recent searches',
  'defaults.clearRecent': 'Clear',
  'defaults.popularSearches': 'Popular searches',
  'defaults.bestSellers': 'Best Sellers',
  'defaults.promos': 'On Sale',
  'defaults.trending': 'Trending Now',

  // Sections
  'section.products': 'Products',
  'section.productCount': '{shown} of {total}',
  'section.articles': 'Articles',
  'section.pages': 'Pages',
  'section.categories': 'Categories',
  'section.collections': 'Collections',
  'section.brands': 'Brands / Producers',
  'section.browse': 'Browse',
  'section.trending': 'Trending Now',
  'section.popularSearches': 'Popular Searches',
  'section.recentSearches': 'Recent Searches',

  // Actions
  'action.clear': 'Clear',

  // Wine types
  'wineType.red': 'Red',
  'wineType.white': 'White',
  'wineType.rose': 'Rosé',
  'wineType.sparkling': 'Sparkling',
  'wineType.dessert': 'Dessert',
  'wineType.fortified': 'Fortified',
  'wineType.orange': 'Orange',
};
